import React, { useState } from "react";
import { CustomMarkdown } from "./AiChatSingleThreaded";

export function JsonNavigator({ data, name, level = 0, md_keys = [] }) {
    const [expanded, setExpanded] = useState(true);

    const isObject = (val) =>
        typeof val === "object" && val !== null && !Array.isArray(val);
    const isArray = Array.isArray(data);
    const isLeaf = !isObject(data) && !Array.isArray(data);
    const isMd = md_keys.includes(name);

    const indentStyle = {
        marginLeft: `${level * 6}px`,
        lineHeight: "1.5",
    };

    const toggle = () => setExpanded((prev) => !prev);

    return (
        <div>
            {name !== undefined && (
                <div style={indentStyle}>
                    <span
                        onClick={isLeaf ? null : toggle}
                        style={{ cursor: "pointer" }}
                    >
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ width: 16 }}>
                                {!isLeaf && <>{expanded ? "-" : "+"}</>}
                            </div>
                            {data && (
                                <div>
                                    {name}:{" "}
                                    {(isLeaf || !expanded) && (
                                        <>
                                            {isArray ? (
                                                "[ ... ]"
                                            ) : typeof data === "object" ? (
                                                "{ ... }"
                                            ) : isMd ? (
                                                <CustomMarkdown>
                                                    {String(data)}
                                                </CustomMarkdown>
                                            ) : (
                                                String(data)
                                            )}
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    </span>
                </div>
            )}

            {expanded && (
                <div style={indentStyle}>
                    {Array.isArray(data)
                        ? data.map((item, idx) => (
                              <JsonNavigator
                                  key={idx}
                                  data={item}
                                  name={`[ ${idx} ]`}
                                  level={level + 1}
                                  md_keys={md_keys}
                              />
                          ))
                        : isObject(data)
                          ? Object.entries(data).map(([key, val]) => (
                                <JsonNavigator
                                    key={key}
                                    data={val}
                                    name={key}
                                    level={level + 1}
                                    md_keys={md_keys}
                                />
                            ))
                          : null}
                </div>
            )}
        </div>
    );
}
